import { ItemsPerPage } from '@billy/design-system'

import { useFetchSalesDocuments } from './useFetchSalesDocuments'

interface UseHasInvoicesProps {
  customerId?: string
  enabled?: boolean
}

export const useHasInvoices = ({ customerId, enabled }: UseHasInvoicesProps = {}) => {
  const {
    documents: invoices,
    isFetching,
    isLoading,
    isSuccess,
  } = useFetchSalesDocuments({
    ...(customerId ? { customerId } : {}),
    documentsListType: 'invoices',
    isEnabled: enabled ?? true,
    page: 1,
    pageSize: 1 as ItemsPerPage,
  })

  const hasInvoices = isSuccess && invoices.length > 0

  return { isFetching, isLoading, hasInvoices }
}
